<template>
  <div>
    <input
      type="file"
      id="certificate-other-file"
      ref="file"
      v-on:change="handleFileUpload()"
      style="display: none"
      @click="$refs.file.value = null"
    />
    <button class="w-full mt-5 btn btn-secondary btn-size-medium" @click="$refs.file.click()">
      Select File
    </button>
    <p class="my-3">
      <small>{{ file.name }}</small>
    </p>
    <button
      class="w-full my-4 btn btn-secondary btn-size-medium includedIcon"
      @click="submitFile()"
    >
      <upload-icon />Upload Certificate
    </button>
    <vs-progress indeterminate color="primary" v-if="uploadingCTCertificate"></vs-progress>
  </div>
</template>

<script>
import { successToast, errorToast } from '@/utils/toast';
import store from '@/store/store';
import theApi from '@/mixins/theApi';
import { UploadIcon } from 'vue-feather-icons';

export default {
  components: {
    UploadIcon,
  },
  data() {
    return {
      file: '',
      certificateUploadUrl:
        $vjeConfig.VUE_APP_API_URL + 'student/workplace_safety/uploadCertificateOther',
      uploadingCTCertificate: false,
    };
  },
  computed: {
    uploadedCertificatesUrl() {
      return store.getters['authStudent/preworkWorkplaceSafetyOther'];
    },
  },
  methods: {
    async submitFile() {
      if (this.uploadedCertificatesUrl) {
        const existed = this.uploadedCertificatesUrl.find((file) => file.name === this.file.name);

        if (existed) {
          this.$toast.error('A file with the same name already exists', errorToast());
          return;
        }
      }

      this.uploadingCTCertificate = true;
      let formData = new FormData();
      formData.append('file', this.file);
      formData.append('type', '2');

      theApi.methods
        .makeCall(false, 'workplace_safety/uploadCertificateOther', 'post', formData, false, true)
        .then(
          (data) => {
            this.file = '';
            if (data.status == 'OK') {
              store.commit('authStudent/preworkAddOtherWSCert', data.file);
            }
            this.uploadingCTCertificate = false;
          },
          () => {
            this.uploadingCTCertificate = false;
          },
        );
    },
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
    },
  },
};
</script>
